/* GENERATED FILE — do not edit by hand.
 * Regenerate with: bun packages/icons/scripts/generate-map.ts
 *
 * Maps every ri-* class that existed in the codebase to its lucide-react
 * equivalent. `filled` marks the icons Remix drew as a solid glyph (-fill),
 * which <Icon> renders by filling Lucide's outline shape.
 * 300 icons, 213 distinct Lucide components,
 * 9 local brand marks. */
import type { ComponentType } from "react";
import {
  Accessibility,
  Activity,
  AlarmClock,
  Anchor,
  Armchair,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  ArrowUpRight,
  AtSign,
  Ban,
  BatteryCharging,
  BedDouble,
  Bell,
  BellOff,
  BookOpen,
  Bookmark,
  Briefcase,
  Building,
  Building2,
  Bus,
  Cake,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarX,
  Camera,
  Car,
  ChartGantt,
  ChartLine,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsRight,
  Circle,
  CircleCheck,
  CircleDollarSign,
  CircleDot,
  CircleHelp,
  CirclePlus,
  CircleUser,
  CircleX,
  ClipboardList,
  Clock,
  CloudSun,
  Cloudy,
  Coffee,
  Coins,
  Compass,
  Copy,
  CornerDownRight,
  CornerUpLeft,
  CreditCard,
  Crown,
  DoorOpen,
  Download,
  Droplet,
  Edit,
  Edit2,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  FileLock2,
  FileText,
  Flag,
  Flame,
  Flashlight,
  FlaskConical,
  Flower,
  Focus,
  Footprints,
  Fuel,
  Fullscreen,
  Gauge,
  Gift,
  Globe,
  Grid,
  GripVertical,
  HandCoins,
  HandHeart,
  Headset,
  Heart,
  HeartHandshake,
  History,
  Home,
  Hotel,
  Hourglass,
  Image,
  Info,
  Key,
  Keyboard,
  Landmark,
  Languages,
  Layers,
  LayoutGrid,
  Leaf,
  Lightbulb,
  Link,
  ListCheck,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Luggage,
  Mail,
  MailCheck,
  MailOpen,
  Map,
  MapPin,
  MapPinPlus,
  MapPinned,
  Maximize2,
  Medal,
  Menu,
  MessageCircle,
  MessageCirclePlus,
  MessageSquare,
  Mic,
  Minimize2,
  Minus,
  Moon,
  Mountain,
  MousePointer2,
  Move,
  Music,
  Music2,
  Navigation,
  Newspaper,
  Palette,
  Paperclip,
  PenTool,
  Pencil,
  Phone,
  PieChart,
  Pin,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  Play,
  PlayCircle,
  Plus,
  Printer,
  Quote,
  RadioTower,
  Receipt,
  RefreshCw,
  Repeat2,
  RotateCcw,
  Route,
  Ruler,
  Sailboat,
  Scale,
  ScanSearch,
  Scissors,
  Search,
  Send,
  Settings,
  Shapes,
  Share,
  Share2,
  ShieldCheck,
  Ship,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  Shuffle,
  SlidersHorizontal,
  Smartphone,
  Smile,
  SortAsc,
  Sparkles,
  Speech,
  Sprout,
  Star,
  StickyNote,
  Sun,
  Tag,
  Target,
  Tent,
  Thermometer,
  ThumbsUp,
  Ticket,
  TicketPercent,
  Trash2,
  TriangleAlert,
  Trophy,
  Umbrella,
  Undo2,
  User,
  UserRoundCheck,
  Users,
  Utensils,
  UtensilsCrossed,
  Volleyball,
  Volume2,
  VolumeX,
  Wallet,
  Wand2,
  Waves,
  Wifi,
  Wind,
  Wine,
  X,
} from "lucide-react";
import { Apple, Facebook, GooglePlay, Instagram, LinkedIn, Pinterest, TikTok, TwitterX, WhatsApp } from "./brand";

export type IconEntry = { C: ComponentType<any>; filled: boolean };

export const ICON_MAP: Record<string, IconEntry> = {
  "ri-accessible-line": { C: Accessibility, filled: false },
  "ri-account-circle-line": { C: CircleUser, filled: false },
  "ri-add-circle-fill": { C: CirclePlus, filled: true },
  "ri-add-circle-line": { C: CirclePlus, filled: false },
  "ri-add-line": { C: Plus, filled: false },
  "ri-alarm-line": { C: AlarmClock, filled: false },
  "ri-alert-line": { C: TriangleAlert, filled: false },
  "ri-anchor-line": { C: Anchor, filled: false },
  "ri-ancient-gate-line": { C: Landmark, filled: false },
  "ri-apple-fill": { C: Apple, filled: true },
  "ri-arrow-down-line": { C: ArrowDown, filled: false },
  "ri-arrow-down-s-line": { C: ChevronDown, filled: false },
  "ri-arrow-go-back-line": { C: Undo2, filled: false },
  "ri-arrow-left-line": { C: ArrowLeft, filled: false },
  "ri-arrow-left-right-line": { C: ArrowLeftRight, filled: false },
  "ri-arrow-left-s-line": { C: ChevronLeft, filled: false },
  "ri-arrow-right-double-line": { C: ChevronsRight, filled: false },
  "ri-arrow-right-line": { C: ArrowRight, filled: false },
  "ri-arrow-right-s-line": { C: ChevronRight, filled: false },
  "ri-arrow-right-up-line": { C: ArrowUpRight, filled: false },
  "ri-arrow-up-down-line": { C: ArrowUpDown, filled: false },
  "ri-arrow-up-line": { C: ArrowUp, filled: false },
  "ri-arrow-up-s-line": { C: ChevronUp, filled: false },
  "ri-article-line": { C: Newspaper, filled: false },
  "ri-at-line": { C: AtSign, filled: false },
  "ri-attachment-2": { C: Paperclip, filled: false },
  "ri-bank-card-line": { C: CreditCard, filled: false },
  "ri-bank-line": { C: Landmark, filled: false },
  "ri-battery-2-charge-fill": { C: BatteryCharging, filled: true },
  "ri-bear-smile-line": { C: Smile, filled: false },
  "ri-book-open-line": { C: BookOpen, filled: false },
  "ri-bookmark-fill": { C: Bookmark, filled: true },
  "ri-bookmark-line": { C: Bookmark, filled: false },
  "ri-building-2-line": { C: Building2, filled: false },
  "ri-building-4-fill": { C: Building, filled: true },
  "ri-building-line": { C: Building, filled: false },
  "ri-bus-line": { C: Bus, filled: false },
  "ri-cake-3-line": { C: Cake, filled: false },
  "ri-calendar-2-fill": { C: Calendar, filled: true },
  "ri-calendar-2-line": { C: Calendar, filled: false },
  "ri-calendar-check-line": { C: CalendarCheck, filled: false },
  "ri-calendar-close-line": { C: CalendarX, filled: false },
  "ri-calendar-event-line": { C: CalendarDays, filled: false },
  "ri-calendar-line": { C: Calendar, filled: false },
  "ri-calendar-schedule-line": { C: CalendarClock, filled: false },
  "ri-camera-line": { C: Camera, filled: false },
  "ri-car-line": { C: Car, filled: false },
  "ri-chat-1-line": { C: MessageCircle, filled: false },
  "ri-chat-3-line": { C: MessageCircle, filled: false },
  "ri-chat-4-line": { C: MessageSquare, filled: false },
  "ri-chat-new-line": { C: MessageCirclePlus, filled: false },
  "ri-check-double-fill": { C: CheckCheck, filled: true },
  "ri-check-double-line": { C: CheckCheck, filled: false },
  "ri-check-line": { C: Check, filled: false },
  "ri-checkbox-circle-fill": { C: CircleCheck, filled: true },
  "ri-checkbox-circle-line": { C: CircleCheck, filled: false },
  "ri-circle-fill": { C: Circle, filled: true },
  "ri-close-circle-fill": { C: CircleX, filled: true },
  "ri-close-circle-line": { C: CircleX, filled: false },
  "ri-close-line": { C: X, filled: false },
  "ri-cloudy-line": { C: Cloudy, filled: false },
  "ri-coin-line": { C: Coins, filled: false },
  "ri-collapse-diagonal-line": { C: Minimize2, filled: false },
  "ri-community-line": { C: Building2, filled: false },
  "ri-compass-3-fill": { C: Compass, filled: true },
  "ri-compass-3-line": { C: Compass, filled: false },
  "ri-compass-discover-line": { C: Compass, filled: false },
  "ri-contrast-drop-fill": { C: Droplet, filled: true },
  "ri-corner-down-right-line": { C: CornerDownRight, filled: false },
  "ri-corner-up-left-line": { C: CornerUpLeft, filled: false },
  "ri-coupon-3-line": { C: TicketPercent, filled: false },
  "ri-cup-line": { C: Coffee, filled: false },
  "ri-cursor-line": { C: MousePointer2, filled: false },
  "ri-customer-service-2-line": { C: Headset, filled: false },
  "ri-customer-service-line": { C: Headset, filled: false },
  "ri-delete-bin-line": { C: Trash2, filled: false },
  "ri-door-open-line": { C: DoorOpen, filled: false },
  "ri-double-quotes-l": { C: Quote, filled: false },
  "ri-download-2-line": { C: Download, filled: false },
  "ri-draft-line": { C: FileText, filled: false },
  "ri-drag-move-line": { C: Move, filled: false },
  "ri-draggable": { C: GripVertical, filled: false },
  "ri-drop-fill": { C: Droplet, filled: true },
  "ri-drop-line": { C: Droplet, filled: false },
  "ri-edit-2-line": { C: Edit2, filled: false },
  "ri-edit-line": { C: Edit, filled: false },
  "ri-emotion-happy-line": { C: Smile, filled: false },
  "ri-emotion-line": { C: Smile, filled: false },
  "ri-equalizer-2-line": { C: SlidersHorizontal, filled: false },
  "ri-equalizer-line": { C: SlidersHorizontal, filled: false },
  "ri-error-warning-line": { C: TriangleAlert, filled: false },
  "ri-expand-diagonal-line": { C: Maximize2, filled: false },
  "ri-external-link-line": { C: ExternalLink, filled: false },
  "ri-eye-line": { C: Eye, filled: false },
  "ri-eye-off-line": { C: EyeOff, filled: false },
  "ri-facebook-fill": { C: Facebook, filled: true },
  "ri-file-copy-line": { C: Copy, filled: false },
  "ri-file-list-3-line": { C: FileText, filled: false },
  "ri-file-shield-2-line": { C: FileLock2, filled: false },
  "ri-fire-fill": { C: Flame, filled: true },
  "ri-fire-line": { C: Flame, filled: false },
  "ri-flag-line": { C: Flag, filled: false },
  "ri-flashlight-fill": { C: Flashlight, filled: true },
  "ri-flashlight-line": { C: Flashlight, filled: false },
  "ri-flask-line": { C: FlaskConical, filled: false },
  "ri-flight-land-line": { C: PlaneLanding, filled: false },
  "ri-flight-takeoff-line": { C: PlaneTakeoff, filled: false },
  "ri-flower-line": { C: Flower, filled: false },
  "ri-focus-3-line": { C: Focus, filled: false },
  "ri-football-line": { C: Volleyball, filled: false },
  "ri-footprint-fill": { C: Footprints, filled: true },
  "ri-footprint-line": { C: Footprints, filled: false },
  "ri-forbid-2-line": { C: Ban, filled: false },
  "ri-fullscreen-line": { C: Fullscreen, filled: false },
  "ri-gas-station-line": { C: Fuel, filled: false },
  "ri-gift-line": { C: Gift, filled: false },
  "ri-global-line": { C: Globe, filled: false },
  "ri-goblet-line": { C: Wine, filled: false },
  "ri-golf-ball-line": { C: Target, filled: false },
  "ri-google-play-fill": { C: GooglePlay, filled: true },
  "ri-grid-fill": { C: Grid, filled: true },
  "ri-group-2-line": { C: Users, filled: false },
  "ri-group-fill": { C: Users, filled: true },
  "ri-group-line": { C: Users, filled: false },
  "ri-hand-coin-line": { C: HandCoins, filled: false },
  "ri-hand-heart-line": { C: HandHeart, filled: false },
  "ri-heart-3-fill": { C: Heart, filled: true },
  "ri-heart-3-line": { C: Heart, filled: false },
  "ri-heart-fill": { C: Heart, filled: true },
  "ri-heart-line": { C: Heart, filled: false },
  "ri-history-line": { C: History, filled: false },
  "ri-home-4-line": { C: Home, filled: false },
  "ri-home-5-line": { C: Home, filled: false },
  "ri-home-line": { C: Home, filled: false },
  "ri-hotel-bed-line": { C: BedDouble, filled: false },
  "ri-hotel-line": { C: Hotel, filled: false },
  "ri-hourglass-line": { C: Hourglass, filled: false },
  "ri-image-2-line": { C: Image, filled: false },
  "ri-image-line": { C: Image, filled: false },
  "ri-information-line": { C: Info, filled: false },
  "ri-instagram-fill": { C: Instagram, filled: true },
  "ri-key-line": { C: Key, filled: false },
  "ri-keyboard-line": { C: Keyboard, filled: false },
  "ri-landscape-line": { C: Mountain, filled: false },
  "ri-layout-grid-fill": { C: LayoutGrid, filled: true },
  "ri-layout-grid-line": { C: LayoutGrid, filled: false },
  "ri-leaf-fill": { C: Leaf, filled: true },
  "ri-leaf-line": { C: Leaf, filled: false },
  "ri-lightbulb-flash-line": { C: Lightbulb, filled: false },
  "ri-lightbulb-line": { C: Lightbulb, filled: false },
  "ri-line-chart-line": { C: ChartLine, filled: false },
  "ri-link": { C: Link, filled: false },
  "ri-linkedin-fill": { C: LinkedIn, filled: true },
  "ri-links-line": { C: Link, filled: false },
  "ri-list-check": { C: ListCheck, filled: false },
  "ri-list-check-2": { C: ListCheck, filled: false },
  "ri-list-check-3": { C: ListCheck, filled: false },
  "ri-loader-4-line": { C: Loader, filled: false },
  "ri-lock-2-line": { C: Lock, filled: false },
  "ri-lock-line": { C: Lock, filled: false },
  "ri-login-box-line": { C: LogIn, filled: false },
  "ri-logout-box-line": { C: LogOut, filled: false },
  "ri-magic-line": { C: Wand2, filled: false },
  "ri-mail-check-line": { C: MailCheck, filled: false },
  "ri-mail-line": { C: Mail, filled: false },
  "ri-mail-unread-line": { C: MailOpen, filled: false },
  "ri-map-2-line": { C: Map, filled: false },
  "ri-map-pin-2-fill": { C: MapPin, filled: true },
  "ri-map-pin-2-line": { C: MapPin, filled: false },
  "ri-map-pin-add-line": { C: MapPinPlus, filled: false },
  "ri-map-pin-fill": { C: MapPin, filled: true },
  "ri-map-pin-line": { C: MapPin, filled: false },
  "ri-map-pin-user-line": { C: MapPinned, filled: false },
  "ri-medal-line": { C: Medal, filled: false },
  "ri-menu-2-line": { C: Menu, filled: false },
  "ri-mic-fill": { C: Mic, filled: true },
  "ri-mic-line": { C: Mic, filled: false },
  "ri-money-dollar-circle-line": { C: CircleDollarSign, filled: false },
  "ri-moon-clear-fill": { C: Moon, filled: true },
  "ri-moon-clear-line": { C: Moon, filled: false },
  "ri-moon-fill": { C: Moon, filled: true },
  "ri-moon-line": { C: Moon, filled: false },
  "ri-more-2-fill": { C: EllipsisVertical, filled: true },
  "ri-more-fill": { C: Ellipsis, filled: true },
  "ri-music-2-line": { C: Music2, filled: false },
  "ri-music-line": { C: Music, filled: false },
  "ri-navigation-fill": { C: Navigation, filled: true },
  "ri-navigation-line": { C: Navigation, filled: false },
  "ri-notification-3-line": { C: Bell, filled: false },
  "ri-notification-off-line": { C: BellOff, filled: false },
  "ri-palette-line": { C: Palette, filled: false },
  "ri-parent-line": { C: Users, filled: false },
  "ri-pencil-line": { C: Pencil, filled: false },
  "ri-phone-line": { C: Phone, filled: false },
  "ri-pie-chart-line": { C: PieChart, filled: false },
  "ri-pinterest-fill": { C: Pinterest, filled: true },
  "ri-plane-line": { C: Plane, filled: false },
  "ri-plant-line": { C: Sprout, filled: false },
  "ri-play-circle-line": { C: PlayCircle, filled: false },
  "ri-play-fill": { C: Play, filled: true },
  "ri-price-tag-3-line": { C: Tag, filled: false },
  "ri-printer-line": { C: Printer, filled: false },
  "ri-pulse-line": { C: Activity, filled: false },
  "ri-pushpin-fill": { C: Pin, filled: true },
  "ri-pushpin-line": { C: Pin, filled: false },
  "ri-question-line": { C: CircleHelp, filled: false },
  "ri-questionnaire-line": { C: ClipboardList, filled: false },
  "ri-quill-pen-line": { C: PenTool, filled: false },
  "ri-receipt-line": { C: Receipt, filled: false },
  "ri-record-circle-line": { C: CircleDot, filled: false },
  "ri-refresh-line": { C: RefreshCw, filled: false },
  "ri-repeat-2-line": { C: Repeat2, filled: false },
  "ri-reserved-line": { C: Armchair, filled: false },
  "ri-restart-line": { C: RotateCcw, filled: false },
  "ri-restaurant-2-fill": { C: Utensils, filled: true },
  "ri-restaurant-2-line": { C: Utensils, filled: false },
  "ri-restaurant-fill": { C: UtensilsCrossed, filled: true },
  "ri-restaurant-line": { C: UtensilsCrossed, filled: false },
  "ri-road-map-line": { C: Map, filled: false },
  "ri-roadster-line": { C: Car, filled: false },
  "ri-route-line": { C: Route, filled: false },
  "ri-ruler-line": { C: Ruler, filled: false },
  "ri-run-line": { C: Footprints, filled: false },
  "ri-sailboat-line": { C: Sailboat, filled: false },
  "ri-scales-3-line": { C: Scale, filled: false },
  "ri-scissors-cut-line": { C: Scissors, filled: false },
  "ri-search-eye-line": { C: ScanSearch, filled: false },
  "ri-search-line": { C: Search, filled: false },
  "ri-send-plane-2-line": { C: Send, filled: false },
  "ri-send-plane-fill": { C: Send, filled: true },
  "ri-settings-3-line": { C: Settings, filled: false },
  "ri-shapes-fill": { C: Shapes, filled: true },
  "ri-share-forward-line": { C: Share2, filled: false },
  "ri-share-line": { C: Share, filled: false },
  "ri-shield-check-fill": { C: ShieldCheck, filled: true },
  "ri-shield-check-line": { C: ShieldCheck, filled: false },
  "ri-shield-keyhole-line": { C: ShieldCheck, filled: false },
  "ri-shield-user-line": { C: ShieldCheck, filled: false },
  "ri-ship-line": { C: Ship, filled: false },
  "ri-shopping-bag-3-line": { C: ShoppingBag, filled: false },
  "ri-shopping-bag-line": { C: ShoppingBag, filled: false },
  "ri-shopping-basket-line": { C: ShoppingBasket, filled: false },
  "ri-shuffle-line": { C: Shuffle, filled: false },
  "ri-signal-tower-fill": { C: RadioTower, filled: true },
  "ri-smartphone-line": { C: Smartphone, filled: false },
  "ri-sort-asc": { C: SortAsc, filled: false },
  "ri-sparkling-2-fill": { C: Sparkles, filled: true },
  "ri-sparkling-2-line": { C: Sparkles, filled: false },
  "ri-sparkling-fill": { C: Sparkles, filled: true },
  "ri-sparkling-line": { C: Sparkles, filled: false },
  "ri-speed-up-fill": { C: Gauge, filled: true },
  "ri-stack-line": { C: Layers, filled: false },
  "ri-star-fill": { C: Star, filled: true },
  "ri-star-line": { C: Star, filled: false },
  "ri-star-smile-line": { C: Star, filled: false },
  "ri-steering-2-line": { C: Car, filled: false },
  "ri-sticky-note-fill": { C: StickyNote, filled: true },
  "ri-sticky-note-line": { C: StickyNote, filled: false },
  "ri-subtract-line": { C: Minus, filled: false },
  "ri-suitcase-3-line": { C: Luggage, filled: false },
  "ri-suitcase-line": { C: Briefcase, filled: false },
  "ri-sun-fill": { C: Sun, filled: true },
  "ri-sun-foggy-line": { C: CloudSun, filled: false },
  "ri-sun-line": { C: Sun, filled: false },
  "ri-t-shirt-line": { C: Shirt, filled: false },
  "ri-taxi-line": { C: Car, filled: false },
  "ri-team-line": { C: Users, filled: false },
  "ri-temp-hot-fill": { C: Thermometer, filled: true },
  "ri-tent-line": { C: Tent, filled: false },
  "ri-thumb-up-line": { C: ThumbsUp, filled: false },
  "ri-ticket-2-fill": { C: Ticket, filled: true },
  "ri-ticket-2-line": { C: Ticket, filled: false },
  "ri-tiktok-fill": { C: TikTok, filled: true },
  "ri-time-fill": { C: Clock, filled: true },
  "ri-time-line": { C: Clock, filled: false },
  "ri-timeline-view": { C: ChartGantt, filled: false },
  "ri-translate-2": { C: Languages, filled: false },
  "ri-trophy-line": { C: Trophy, filled: false },
  "ri-twitter-x-fill": { C: TwitterX, filled: true },
  "ri-twitter-x-line": { C: TwitterX, filled: false },
  "ri-umbrella-line": { C: Umbrella, filled: false },
  "ri-user-3-line": { C: User, filled: false },
  "ri-user-heart-line": { C: HeartHandshake, filled: false },
  "ri-user-line": { C: User, filled: false },
  "ri-user-smile-line": { C: Smile, filled: false },
  "ri-user-star-line": { C: UserRoundCheck, filled: false },
  "ri-user-voice-line": { C: Speech, filled: false },
  "ri-vip-crown-line": { C: Crown, filled: false },
  "ri-volume-mute-line": { C: VolumeX, filled: false },
  "ri-volume-up-line": { C: Volume2, filled: false },
  "ri-walk-line": { C: Footprints, filled: false },
  "ri-wallet-3-line": { C: Wallet, filled: false },
  "ri-water-flash-fill": { C: Waves, filled: true },
  "ri-water-flash-line": { C: Waves, filled: false },
  "ri-whatsapp-line": { C: WhatsApp, filled: false },
  "ri-wheelchair-line": { C: Accessibility, filled: false },
  "ri-wifi-fill": { C: Wifi, filled: true },
  "ri-wifi-line": { C: Wifi, filled: false },
  "ri-windy-line": { C: Wind, filled: false },
  "ri-x": { C: X, filled: false },
};

export type IconName = keyof typeof ICON_MAP;
